// extracted by mini-css-extract-plugin
module.exports = {"root":"_1NuoieZKXDy8","item":"_3uCtmubdQP6F"};